import React, { useEffect, useState } from 'react';
import { breakpoints } from '../common/constants';
import { withOptimizely, WithOptimizelyProps } from 'shared/optimizely';
import {
    DFP_AD_UNIT,
    Size,
    AD_UNIT_ROOTS
} from 'shared/components/Adverts/types';
import { getPageSuffixForAdUnit } from 'shared/components/Adverts/lib/pageTargeting';
import { AdvertSlotDfp } from 'shared/components/Adverts/AdvertSlotDfp';
import { PAGE_MAPPING } from 'shared/components/Adverts/constants';
type SlotConfig = {
    listingZeroIdxPos: number;
    adUnitCode?: DFP_AD_UNIT;
    collapseEmpty?: boolean;
    sizes: Size[];
    position?: number;
};

const DEFAULT_DESKTOP_SIZES: Size[] = [[728, 90], [728, 110], 'fluid'];

export const DESKTOP_LSRP_AD_SLOT_POSITIONS: SlotConfig[] = [
    {
        listingZeroIdxPos: 2,
        collapseEmpty: true,
        sizes: DEFAULT_DESKTOP_SIZES,
        position: 0
    },
    {
        listingZeroIdxPos: 7,
        collapseEmpty: true,
        sizes: DEFAULT_DESKTOP_SIZES,
        position: 1
    },
    {
        listingZeroIdxPos: 12,
        collapseEmpty: true,
        sizes: DEFAULT_DESKTOP_SIZES,
        position: 2
    },
    {
        listingZeroIdxPos: 17,
        collapseEmpty: true,
        sizes: DEFAULT_DESKTOP_SIZES,
        position: 3
    },
    {
        listingZeroIdxPos: 22,
        collapseEmpty: true,
        sizes: DEFAULT_DESKTOP_SIZES,
        position: 4
    }
];

const DEFAULT_MOBILE_SIZES: Size[] = [[320, 50], 'fluid'];

export const MOBILE_LSRP_AD_SLOT_POSITIONS: SlotConfig[] = [
    {
        listingZeroIdxPos: 0,
        adUnitCode: DFP_AD_UNIT.ZOOPLA_EXPERIAN_LOANSWAREHOUSE_MOBILE,
        sizes: DEFAULT_MOBILE_SIZES,
        position: 0
    },
    {
        listingZeroIdxPos: 7,
        collapseEmpty: true,
        sizes: DEFAULT_MOBILE_SIZES,
        position: 1
    },
    {
        listingZeroIdxPos: 12,
        collapseEmpty: true,
        sizes: DEFAULT_MOBILE_SIZES,
        position: 2
    },
    {
        listingZeroIdxPos: 17,
        collapseEmpty: true,
        sizes: DEFAULT_MOBILE_SIZES,
        position: 3
    },
    {
        listingZeroIdxPos: 22,
        collapseEmpty: true,
        sizes: DEFAULT_MOBILE_SIZES,
        position: 4
    }
];

const IntegratedListingAdSlot: React.FC<
    {
        useMobileConfig: boolean;
        listingIndex: number;
    } & WithOptimizelyProps
> = ({ useMobileConfig, listingIndex, optimizely }) => {
    const [mobileAdSlots, setMobileAdSlots] = useState(
        MOBILE_LSRP_AD_SLOT_POSITIONS
    );

    const isExperianMobileShiftActive =
        optimizely?.activate('experian_mobile_shift__af-733_') === 'moved-ad';

    useEffect(() => {
        if (isExperianMobileShiftActive) {
            const [defaultExperianAd, ...restOfMobileAds] = mobileAdSlots;
            const experimentalExperianAd = {
                ...defaultExperianAd,
                listingZeroIdxPos: 3,
                adUnitCode:
                    DFP_AD_UNIT.ZOOPLA_EXPERIAN_LOANSWAREHOUSE_MOBILE_EXPERIMENT
            };
            setMobileAdSlots([experimentalExperianAd, ...restOfMobileAds]);
        }
    }, []);

    const adArray = useMobileConfig
        ? mobileAdSlots
        : DESKTOP_LSRP_AD_SLOT_POSITIONS;

    const confIndex = adArray.findIndex(
        ({ listingZeroIdxPos }) => listingZeroIdxPos === listingIndex
    );

    if (confIndex === -1) return null;

    return (
        <AdvertSlotDfp
            showOnly={[useMobileConfig ? '<' : '>', breakpoints.lsrpSidebar]}
            sizes={adArray[confIndex].sizes}
            position={adArray[confIndex].position || 0}
            adUnitCode={
                adArray[confIndex].adUnitCode || [
                    AD_UNIT_ROOTS.INTERSTITIAL,
                    getPageSuffixForAdUnit(PAGE_MAPPING),
                    '/Slot-' + ((adArray[confIndex].position || 0) + 1)
                ]
            }
            collapseEmpty={adArray[confIndex].collapseEmpty}
        />
    );
};

export const IntegratedAdSlotWithOptimizely = withOptimizely(
    IntegratedListingAdSlot
);
